<template>
  <div
    class="h-full relative overflow-hidden flex flex-col justify-center items-center"
  >
    <span
      class="w-208 h-3.5 text-center bg-vivid-pink font-mulish-bold text-white text-2 leading-2.2 tracking-wider px-2 flex items-center justify-center"
      >4. Guild Missions</span
    >
    <div class="mt-14 xl:w-3/12 lg:w-3/12">
      <img
        class="w-full"
        :src="`${imgPath}/SystemChanges/guildrework_4.png`"
        alt="guildrework"
      />
    </div>
    <p
      class="4xl:w-4/12 2xl:w-5/12 xl:w-7/12 lg:w-8/12 font-mulish-medium text-very-pale-orange xl:text-1.8 lg:text-1.4 leading-2 xl:tracking-wider lg:tracking-tight mt-14 text-center"
    >
      Guild members can collect guild points for a week to earn step-by-step
      rewards. <br />
      Guild missions reset every week. Rewards can be earned from guild missions
      conducted the previous week, and only collect once per account.<br />
      (Button disabled after claiming rewards)
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style></style>
